import { Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'
import MoneyWithCurrency from 'modules/core/lib/money'

export const useManagedExpensesLimits = () => {
  const { loading, refetch, featureAvailability } = useFeatureAvailability(
    Features.expenses_monthly_managed_expenses
  )

  const {
    access: { locale },
  } = useCurrentSession()

  const limitReached = () => {
    return !!(
      hasFeature('dev_packaging_paywalls') &&
      !featureAvailability.available &&
      'usageLimit' in featureAvailability &&
      featureAvailability.usageLimit
    )
  }

  const limitNearlyReached = () => {
    if (
      !hasFeature('dev_packaging_paywalls') ||
      !featureAvailability.available ||
      !('usageLimit' in featureAvailability)
    )
      return false

    if (
      !featureAvailability.usage ||
      !featureAvailability.usageLimit ||
      featureAvailability.usageLimit == -1
    )
      return false

    return featureAvailability.usage / featureAvailability.usageLimit >= 0.9
  }

  const unitPrice = () => {
    if ('usageLimit' in featureAvailability && featureAvailability.currencyCode) {
      return MoneyWithCurrency({
        amount: Number(featureAvailability.additionalUnitPrice) * 100,
        currency: featureAvailability.currencyCode,
        locale,
      })
    }
  }

  const usageLimit = () => {
    if ('usageLimit' in featureAvailability) {
      return featureAvailability.usageLimit
    }
  }

  const extraUsage = () => {
    if (
      limitReached() &&
      'usageLimit' in featureAvailability &&
      featureAvailability.usage &&
      featureAvailability.usageLimit
    ) {
      return featureAvailability.usage - featureAvailability.usageLimit
    }
  }

  return {
    loading,
    refetch,
    limitReached: limitReached(),
    limitNearlyReached: limitNearlyReached(),
    usageLimit: usageLimit(),
    unitPrice: unitPrice(),
    extraUsage: extraUsage(),
  }
}
